(function () {
  'use strict';

  angular.module('ringbaPortal').component('inlineConfirmationDialog', {
    bindings: {
      dialogTitle: '@',
      submitText: '@',
      cancelText: '@',
      onSubmit: '&',
      onCancel: '&',
      disableSubmit: '<'
    },
    transclude: true,
    controller: InlineConfirmationDialogController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/inline-confirmation-dialog/inline-confirmation-dialog.view.html'
  });

  function InlineConfirmationDialogController() {
    'ngInject';
  }
})();
